var _path, _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgContentRatingW = function SvgContentRatingW(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3C0 1.34315 1.34315 0 3 0H18C19.6569 0 21 1.34315 21 3V18C21 19.6569 19.6569 21 18 21H3C1.34315 21 0 19.6569 0 18V3Z",
    fill: "#929497"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2284_11042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 3L14.7432 18H12.9807L10.6886 7.75104C10.6257 7.50207 10.5677 7.19779 10.5145 6.83817C10.4855 7.01107 10.4565 7.17358 10.4275 7.32573C10.3985 7.47787 10.367 7.61964 10.3332 7.75104L8.01934 18H6.24952L3 3H4.63201C4.80126 3 4.94149 3.05878 5.05271 3.17635C5.16876 3.287 5.24613 3.43914 5.28482 3.63278L7.06915 12.6058C7.10783 12.8271 7.1441 13.0692 7.17795 13.332C7.21663 13.5878 7.25532 13.8575 7.294 14.1411C7.33269 13.8506 7.37379 13.5775 7.41731 13.3216C7.46567 13.0657 7.51644 12.8271 7.56963 12.6058L9.62959 3.63278C9.66828 3.47372 9.74323 3.32849 9.85445 3.1971C9.9705 3.0657 10.1107 3 10.2751 3H10.8482C11.0174 3 11.1552 3.05878 11.2616 3.17635C11.368 3.29391 11.4478 3.44606 11.501 3.63278L13.5537 12.6058C13.6552 13.0346 13.7471 13.529 13.8293 14.0892C13.8922 13.5429 13.9623 13.0484 14.0397 12.6058L15.824 3.63278C15.853 3.45989 15.9255 3.3112 16.0416 3.18672C16.1625 3.06224 16.3051 3 16.4695 3H18Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2284_11042",
    x: 1,
    y: 1,
    width: 19,
    height: 19,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2284_11042"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2284_11042",
    result: "shape"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContentRatingW, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/content_rating_w.b2bf5c7f.svg";
export { ForwardRef as ReactComponent };